export default {
    category: {
        cta: "Zobacz produkty"
    }
}